import moment from 'moment/min/moment.min';

const log = x => { console.warn(x); return x }

// let intervalID = null;
// let actions = [];
// let executeActions = () => actions.filter( a => typeof(a)==='function').forEach( a => a() );

// if(!intervalID)
//     intervalID = setInterval( executeActions, 1000);


export class Timer {
    static create(startCountDownFrom=-1, startCountingFromDate='', period=1000) {
        return new Timer(startCountDownFrom, startCountingFromDate, period);
    }


    constructor(startCountDownFrom=-1, startCountingFromDate='', period=1000) {
        this.counterID  = undefined
        this.pausing    = false
        this.period     = period
        this.seconds    = this.calcDeltaToStartDate(startCountingFromDate)
        this.countDown  = startCountDownFrom - this.seconds

        this.seconds    = this.seconds<0 ? 0 : this.seconds
        this.countDown  = this.countDown<0 ? 0 : this.countDown
    }

    calcDeltaToStartDate(startDate) {
        if(!moment(startDate).isValid())
            return 0;

        let startDuration = moment() - moment(startDate)
        return moment.duration(startDuration).asSeconds()
    }


    start(reset=true) {
        if(reset) this.reset();
        this.counterID = setInterval(()=>this.count(), this.period);
    }
    pause()  { this.pausing=true; }
    resume() { this.pausing=false; }
    stop() {
        clearInterval(this.counterID);
        this.reset();
    }
    reset() {
        this.countDown += this.seconds;
        this.seconds = 0;
    }


    count()
    {
        if(!this.pausing)
        {
            this.seconds++
            this.countDown--
        }
    }


    getSeconds()            { return this.getDuration().seconds(); }
    getMinutes()            { return this.getDuration().minutes(); }
    getHours()              { return this.getDuration().hours(); }
    getDurationAsSeconds()  { return this.getDuration().asSeconds(); }
    getDuration()           { return moment.duration(this.seconds, 'seconds'); }

    getCountDownSign()      { return (this.countDown<0) ? '' : ''; }
    getCountDownSeconds()   { return this.getCountDownDuration().seconds(); }
    getCountDownMinutes()   { return this.getCountDownDuration().minutes(); }
    getCountDownHours()     { return this.getCountDownDuration().hours(); }
    getCountDownDuration()  { return moment.duration(Math.abs(this.countDown), 'seconds'); }
    getCountDownDurationAsSeconds()  { return this.getCountDownDuration().asSeconds(); }

    static format(number)   { return number<10 ? '0'+number : number; }
    static formatClock(hours, minutes, seconds, all=false, sign='')  {
        let parts = ((hours<=0) && !all) ? [minutes,seconds]
                                         : [hours,minutes,seconds];
        return sign + parts.map(p=>this.format(p)).join(':');
    }
    static formatClockFromSeconds(secs, full) {
        let duration = moment.duration(Math.abs(secs), 'seconds');
        return this.formatClock(duration.hours(),
                                duration.minutes(),
                                duration.seconds(),
                                full);
    }

    formatTimerClock() {
        return Timer.formatClock(   this.getHours(),
                                    this.getMinutes(),
                                    this.getSeconds());
    }
    formatCountDownClock() {
        return Timer.formatClock(   this.getCountDownHours(),
                                    this.getCountDownMinutes(),
                                    this.getCountDownSeconds(),
                                    this.getCountDownSign());
    }
}


export default Timer;
